// removed by extract-text-webpack-plugin
module.exports = {"BreakpointToSmall":"(max-width: 374px)","welcomeSection":"G02f3f0"};